export const InvoiceSubmissionDataStates = {
    IDLE: 'IDLE',
    LOADING: 'LOADING',
    UPDATING: 'UPDATING',
    DOWNLOADING: 'DOWNLOADING',
};
